import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { ZIP_CODE_ANALYTICS_ACTIONS } from '@shared/components/header/zip-code-change/tracking/analytics/zip-code.analytics.actions';
import { ZipCodeAnalyticsMessages } from '@shared/components/header/zip-code-change/tracking/analytics/models/zip-code-messages.analytics';
import { genericAnalyticsTransformer } from '@shared/tracking/analytics/generic-analytics-transformer';

@Injectable({ providedIn: 'root' })
export class ZipCodeAnalyticsService {
  constructor(private store: Store) {}

  trackZipCodeSwitchClick(modalName: string, zipCode: number): void {
    const tracking: Tracking = {
      analytics: {
        data: {
          event: ZipCodeAnalyticsMessages.event,
          capability: ZipCodeAnalyticsMessages.capability,
          button: {
            buttonName: ZipCodeAnalyticsMessages.buttonName,
          },
          modal: {
            name: modalName,
          },
          guest: {
            zipCode: zipCode,
          },
        },
        transformFunc: genericAnalyticsTransformer,
      },
    };

    this.store.dispatch(
      ZIP_CODE_ANALYTICS_ACTIONS.trackZipCodeChange({
        tracking,
      }),
    );
  }
}
